import { SchedulerMainResultModel } from "./schedulerMainResultModel";

export class SyncSchedulerModel {
  public syncSchedulerId: number;
  public nextExecutionDate: string;
  public executedAt: string;
  public mainResult: SchedulerMainResultModel
  // public loadDataReportJSON: string;
  // public importDataReportJSON: string;
  // public syncDataReportJSON: string;
  public isActive: boolean;
}